import CategoryIcon from '@mui/icons-material/Bookmark'
import CategoryEdit from './CategoryEdit'
import CategoryList from './CategoryList'

export default {
  list: CategoryList,
  edit: CategoryEdit,
  icon: CategoryIcon,
}
